import Dexie, { type EntityTable } from "dexie"

export interface IPasswordRow {
    id:string
    value:string
}
const db = new Dexie("password") as Dexie & {
    password: EntityTable<IPasswordRow, "id">
}

db.version(1).stores({
    password: "++id"
})

const drop = () => Dexie.delete("password")
export {db,drop}